<template>
<v-container fluid grid-list-md text-xs-center>
    <v-layout row wrap>
      <v-flex xs12 mb-2 v-if="getFiltersChips">
        <Filters v-bind:filters="getFilters"></Filters>
      </v-flex>

      <v-flex xs12>
        <v-card>
          <v-card-text class="pa-0 grey lighten-2 mb-3">
            <Counters v-bind:counters="['tweets', 'hashtags', 'users', 'countries', 'impressions', 'articles', 'sources']" v-bind:filters="getFilters"></Counters>
          </v-card-text>
        </v-card>
      </v-flex>
      
      <v-flex xs12>
        <v-expansion-panel :value=expansionValue>
          <v-expansion-panel-content class="secondary accent--text" expand-icon="fa-angle-down accent--text">
            <div slot="header">
              <div style="float: left;margin-bottom: 0;line-height: 50px">Tweet Volume</div>
              <v-dialog style="float: right" v-model="tweetsVolumeBarChartDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
                <v-btn slot="activator" color="primary" class='ml-0 mr-2' style="width:30px" icon flat><v-icon style="font-size: 20px">fas fa-expand</v-icon></v-btn>
                <v-flex white style="height: 100%">
                  <v-toolbar dark color="accent" style="height: 65px">
                    <p class="headline mb-0">Tweet Volume</p>
                    <v-spacer></v-spacer>
                    <v-btn flat icon color="primary" style="float: right;" class="mx-0" @click.stop="snap($refs['FullHomeTweetsVolumeBarChart'], 'FullHomeTweetsVolumeBarChart')">
                      <v-icon>get_app</v-icon>
                    </v-btn>
                    <v-btn icon dark @click.native="tweetsVolumeBarChartDialog = false">
                      <v-icon>close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-flex id="FullHomeTweetsVolumeBarChart" ref="FullHomeTweetsVolumeBarChart" style="height: calc(100% - 65px);display:flex;align-items:center;justify-content:center" v-if="tweetsVolumeBarChartDialog">
                    <TweetsVolumeBarChart v-bind:options="{}" v-bind:filters="getFilters"></TweetsVolumeBarChart>
                  </v-flex>
                </v-flex>
              </v-dialog>
              <v-btn style="float: right; width: 30px" flat icon color="primary" class="mx-0" @click.stop="snap($refs['HomeTweetsVolumeBarChart'], 'HomeTweetsVolumeBarChart')">
                <v-icon>get_app</v-icon>
              </v-btn>
            </div>
            <v-card class="d-flex justify-center align-center" style="height: 400px">
              <v-card-text class="px-0" style="height: 100%">
                <center style="height: 100%" id="HomeTweetsVolumeBarChart" ref="HomeTweetsVolumeBarChart">
                  <TweetsVolumeBarChart v-bind:options="{}" v-bind:filters="getFilters"></TweetsVolumeBarChart>
                </center>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>

      <v-flex xs6>
        <v-expansion-panel :value=expansionValue>
          <v-expansion-panel-content class="secondary accent--text" expand-icon="fa-angle-down accent--text">
            <div slot="header">
              <div style="float: left; margin-bottom: 0; line-height: 50px">Hashtags</div>
              <v-dialog style="float: right" v-model="hashtagCloudDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
                <v-btn slot="activator" color="primary" class='ml-0 mr-2' style="width:30px" icon flat><v-icon style="font-size: 20px">fas fa-expand</v-icon></v-btn>
                <v-flex white style="height: 100%">
                  <v-toolbar dark color="accent" style="height: 65px">
                    <p class="headline mb-0">Hashtags</p>
                    <v-spacer></v-spacer>
                    <v-btn flat icon color="primary" style="float: right;" class="mx-0" @click.stop="snap($refs['FullHomeHashtagCloud'], 'FullHomeHashtagCloud')">
                      <v-icon>get_app</v-icon>
                    </v-btn>
                    <v-btn class='mx-0' icon dark @click.native="hashtagCloudDialog = false">
                      <v-icon>close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-flex id="FullHomeHashtagCloud" ref="FullHomeHashtagCloud" style="height: calc(100% - 65px);display:flex;align-items:center;justify-content:center" v-if="hashtagCloudDialog">
                    <HashtagCloud v-bind:options="{}" v-bind:filters="getFilters"></HashtagCloud>
                  </v-flex>
                </v-flex>
              </v-dialog>
              <v-btn flat icon color="primary" style="float: right; width: 30px" class="mx-0" @click.stop="snap($refs['HomeHashtagCloud'], 'HomeHashtagCloud')">
                <v-icon>get_app</v-icon>
              </v-btn>
            </div>
            
            <v-card class="d-flex justify-center align-center" style="min-height: 300px;">
              <v-card-text class="px-0 pt-0">
                <center id="HomeHashtagCloud" ref="HomeHashtagCloud" style="height: 315px;">
                  <HashtagCloud v-bind:options="{}" v-bind:filters="getFilters"></HashtagCloud>
                </center>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>
      
      <v-flex xs6>
        <v-expansion-panel :value=expansionValue>
          <v-expansion-panel-content class="secondary accent--text" expand-icon="fa-angle-down accent--text">
            <div slot="header">
              <div style="float: left; margin-bottom: 0; line-height: 50px">Emojis</div>
              <v-dialog style="float: right" v-model="emojiCloudDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
                <v-btn slot="activator" color="primary" class='ml-0 mr-2' style="width:30px" icon flat><v-icon style="font-size: 20px">fas fa-expand</v-icon></v-btn>
                <v-flex white style="height: 100%">
                  <v-toolbar dark color="accent" style="height: 65px">
                    <p class="headline mb-0">Emojis</p>
                    <v-spacer></v-spacer>
                    <v-btn flat icon color="primary" style="float: right;" class="mx-0" @click.stop="snap($refs['FullHomeEmojiCloud'], 'FullHomeEmojiCloud')">
                      <v-icon>get_app</v-icon>
                    </v-btn>
                    <v-btn class='mx-0' icon dark @click.native="emojiCloudDialog = false">
                      <v-icon>close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-flex id="FullHomeEmojiCloud" ref="FullHomeEmojiCloud" style="height: calc(100% - 65px);display:flex;align-items:center;justify-content:center" v-if="emojiCloudDialog">
                    <EmojiCloud style="min-height: 300px;" v-bind:options="{}" v-bind:filters="getFilters"></EmojiCloud>
                  </v-flex>
                </v-flex>
              </v-dialog>
              <v-btn flat icon color="primary" style="float: right; width: 30px" class="mx-0" @click.stop="snap($refs['HomeEmojiCloud'], 'HomeEmojiCloud')">
                <v-icon>get_app</v-icon>
              </v-btn>
            </div>
            
            <v-card class="d-flex justify-center align-center" style="min-height: 300px;">
              <v-card-text class="px-0 pt-0">
                <center id="HomeEmojiCloud" ref="HomeEmojiCloud" style="height: 315px;">
                  <EmojiCloud style="min-height: 300px;" v-bind:options="{}" v-bind:filters="getFilters"></EmojiCloud>
                </center>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>
      
      <v-flex xs6>
        <v-expansion-panel :value=expansionValue>
          <v-expansion-panel-content class="secondary accent--text" expand-icon="fa-angle-down accent--text">
            <div slot="header">
              <div style="float: left;margin-bottom: 0;line-height: 50px">Countries</div>
              <v-dialog style="float: right" v-model="countriesPieChartDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
                <v-btn slot="activator" color="primary" class='ml-0 mr-2' style="width:30px" icon flat><v-icon style="font-size: 20px">fas fa-expand</v-icon></v-btn>
                <v-flex white style="height: 100%">
                  <v-toolbar dark color="accent" style="height: 65px">
                    <p class="headline mb-0">Countries</p>
                    <v-spacer></v-spacer>
                    <v-btn flat icon color="primary" style="float: right;" class="mx-0" @click.stop="snap($refs['FullHomeTweetsLocationsPieChart'], 'FullHomeTweetsLocationsPieChart')">
                      <v-icon>get_app</v-icon>
                    </v-btn>
                    <v-btn class='mx-0' icon dark @click.native="countriesPieChartDialog = false">
                      <v-icon>close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-flex id="FullHomeTweetsLocationsPieChart" ref="FullHomeTweetsLocationsPieChart" style="height: calc(100% - 65px);display:flex;align-items:center;justify-content:center" v-if="countriesPieChartDialog">
                    <TweetsLocationsPieChart v-bind:options="{}" v-bind:filters="getFilters"></TweetsLocationsPieChart>
                  </v-flex>
                </v-flex>
              </v-dialog>
              <v-btn flat icon color="primary" style="float: right; width: 30px" class="mx-0" @click.stop="snap($refs['HomeTweetsLocationsPieChart'], 'HomeTweetsLocationsPieChart')">
                <v-icon>get_app</v-icon>
              </v-btn>
            </div>
            <v-card style="height: 432px" class="d-flex justify-center align-center">
              <v-card-text class="px-0 pt-0" style="height: 100%">
                <center id="HomeTweetsLocationsPieChart" ref="HomeTweetsLocationsPieChart" style="height: 100%">
                  <TweetsLocationsPieChart v-bind:options="{}" v-bind:filters="getFilters"></TweetsLocationsPieChart>
                </center>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>
      
      <v-flex xs6>
        <v-expansion-panel :value=expansionValue>
          <v-expansion-panel-content class="secondary accent--text" expand-icon="fa-angle-down accent--text">
            <div slot="header">
              <div style="float: left;margin-bottom: 0;line-height: 50px">Tweet Types</div>
              <v-dialog style="float: right" v-model="tweetTypesPieChartDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
                <v-btn slot="activator" color="primary" class='ml-0 mr-2' style="width:30px" icon flat><v-icon style="font-size: 20px">fas fa-expand</v-icon></v-btn>
                <v-flex white style="height: 100%">
                  <v-toolbar dark color="accent" style="height: 65px">
                    <p class="headline mb-0">Tweet Types</p>
                    <v-spacer></v-spacer>
                    <v-btn flat icon color="primary" style="float: right;" class="mx-0" @click.stop="snap($refs['FullHomeTweetsTypesPieChart'], 'FullHomeTweetsTypesPieChart')">
                      <v-icon>get_app</v-icon>
                    </v-btn>
                    <v-btn class='mx-0' icon dark @click.native="tweetTypesPieChartDialog = false">
                      <v-icon>close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-flex id="FullHomeTweetsTypesPieChart" ref="FullHomeTweetsTypesPieChart" style="height: calc(100% - 65px);display:flex;align-items:center;justify-content:center" v-if="tweetTypesPieChartDialog">
                    <TweetsTypesPieChart v-bind:options="{}" v-bind:filters="getFilters"></TweetsTypesPieChart>
                  </v-flex>
                </v-flex>
              </v-dialog>
              <v-btn flat icon color="primary" style="float: right; width: 30px" class="mx-0" @click.stop="snap($refs['HomeTweetsTypesPieChart'], 'HomeTweetsTypesPieChart')">
                <v-icon>get_app</v-icon>
              </v-btn>
            </div>
            <v-card style="height: 432px;" class="d-flex justify-center align-center">
              <v-card-text class="px-0 pt-0" style="height: 100%">
                <center id="HomeTweetsTypesPieChart" ref="HomeTweetsTypesPieChart" style="height: 100%">
                  <TweetsTypesPieChart v-bind:options="{}" v-bind:filters="getFilters"></TweetsTypesPieChart>
                </center>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>

      <v-flex xs6 v-if="getTopListings">
        <v-expansion-panel :value=expansionValue>
          <v-expansion-panel-content class="secondary accent--text" expand-icon="fa-angle-down accent--text">
            <div slot="header">
              <div style="float: left;margin-bottom: 0;line-height: 50px">Top Tweets<span class="caption pl-1">(sorted by number of retweets)</span></div>
              <v-btn flat icon color="primary" class="float: right" @click.stop="snap($refs['HomeTweetsByRetweetsRanking'], 'HomeTweetsByRetweetsRanking')">
                <v-icon>get_app</v-icon>
              </v-btn>
            </div>
            <v-card style="min-height: 432px" class="d-flex justify-center align-center">
              <v-card-text class="px-0 pt-0">
                <center id="HomeTweetsByRetweetsRanking" ref="HomeTweetsByRetweetsRanking">
                  <TweetsByRetweets v-bind:options="{}" v-bind:filters="getFilters"></TweetsByRetweets>
                </center>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>

      <v-flex xs6 v-if="getLatestListings">
        <v-expansion-panel :value=expansionValue>
          <v-expansion-panel-content class="secondary accent--text" expand-icon="fa-angle-down accent--text">
            <div slot="header">
              <div style="float: left;margin-bottom: 0;line-height: 50px">Latest Tweets</div>
              <v-btn flat icon color="primary" class="float: right" @click.stop="snap($refs['HomeTweetsByDateRanking'], 'HomeTweetsByDateRanking')">
                <v-icon>get_app</v-icon>
              </v-btn>
            </div>
            <v-card style="min-height: 432px" class="d-flex justify-center align-center">
              <v-card-text class="px-0 pt-0">
                <center id="HomeTweetsByDateRanking" ref="HomeTweetsByDateRanking">
                  <TweetsByDate v-bind:options="{}" v-bind:filters="getFilters"></TweetsByDate>
                </center>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>

      <v-flex xs6 v-if="getTopListings">
        <v-expansion-panel :value=expansionValue>
          <v-expansion-panel-content class="secondary accent--text" expand-icon="fa-angle-down accent--text">
            <div slot="header">
              <div style="float: left;margin-bottom: 0;line-height: 50px">Top Contributors<span class="caption pl-1">(sorted by number of followers)</span></div>
              <v-btn flat icon color="primary" class="float: right" @click.stop="snap($refs['HomeContributorsByNumberOfFollowersRanking'], 'HomeContributorsByNumberOfFollowersRanking')">
                <v-icon>get_app</v-icon>
              </v-btn>
            </div>
            <v-card style="min-height: 432px" class="d-flex justify-center align-center">
              <v-card-text class="px-0 pt-0">
                <center id="HomeContributorsByNumberOfFollowersRanking" ref="HomeContributorsByNumberOfFollowersRanking">
                  <ContributorsByNumberOfFollowers v-bind:options="{}" v-bind:filters="getFilters"></ContributorsByNumberOfFollowers>
                </center>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>

      <v-flex xs6 v-if="getLatestListings">
        <v-expansion-panel :value=expansionValue>
          <v-expansion-panel-content class="secondary accent--text" expand-icon="fa-angle-down accent--text">
            <div slot="header">
              <div style="float: left;margin-bottom: 0;line-height: 50px">Latest Contributors</div>
              <v-btn flat icon color="primary" class="float: right" @click.stop="snap($refs['HomeContributorsByDateRanking'], 'HomeContributorsByDateRanking')">
                <v-icon>get_app</v-icon>
              </v-btn>
            </div>
            <v-card style="min-height: 432px" class="d-flex justify-center align-center">
              <v-card-text class="px-0 pt-0">
                <center id="HomeContributorsByDateRanking" ref="HomeContributorsByDateRanking">
                  <ContributorsByDate v-bind:options="{}" v-bind:filters="getFilters"></ContributorsByDate>
                </center>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>

      <v-flex xs6 v-if="getTopListings">
        <v-expansion-panel :value=expansionValue>
          <v-expansion-panel-content class="secondary accent--text" expand-icon="fa-angle-down accent--text">
            <div slot="header">
              <div style="float: left;margin-bottom: 0;line-height: 50px">Top Hashtags<span class="caption pl-1">(sorted by number of tweets)</span></div>
              <v-btn flat icon color="primary" class="float: right" @click.stop="snap($refs['HomeHashtagsByNumberOfTweetsRanking'], 'HomeHashtagsByNumberOfTweetsRanking')">
                <v-icon>get_app</v-icon>
              </v-btn>
            </div>
            <v-card style="min-height: 432px" class="d-flex justify-center align-center">
              <v-card-text class="px-0 pt-0">
                <center id="HomeHashtagsByNumberOfTweetsRanking" ref="HomeHashtagsByNumberOfTweetsRanking">
                  <HashtagsByNumberOfTweets v-bind:options="{}" v-bind:filters="getFilters"></HashtagsByNumberOfTweets>
                </center>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>

      <v-flex xs6 v-if="getLatestListings">
        <v-expansion-panel :value=expansionValue>
          <v-expansion-panel-content class="secondary accent--text" expand-icon="fa-angle-down accent--text">
            <div slot="header">
              <div style="float: left;margin-bottom: 0;line-height: 50px">Latest Hashtags</div>
              <v-btn flat icon color="primary" class="float: right" @click.stop="snap($refs['HomeHashtagsByDateRanking'], 'HomeHashtagsByDateRanking')">
                <v-icon>get_app</v-icon>
              </v-btn>
            </div>
            <v-card style="min-height: 432px" class="d-flex justify-center align-center">
              <v-card-text class="px-0 pt-0">
                <center id="HomeHashtagsByDateRanking" ref="HomeHashtagsByDateRanking">
                  <HashtagsByDate v-bind:options="{}" v-bind:filters="getFilters"></HashtagsByDate>
                </center>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>

      <v-flex xs6 v-if="getTopListings">
        <v-expansion-panel :value=expansionValue>
          <v-expansion-panel-content class="secondary accent--text" expand-icon="fa-angle-down accent--text">
            <div slot="header">
              <div style="float: left;margin-bottom: 0;line-height: 50px">Top Sources<span class="caption pl-1">(sorted by number of articles)</span></div>
              <v-btn flat icon color="primary" class="float: right" @click.stop="snap($refs['HomeSourcesByNumberOfArticlesRanking'], 'HomeSourcesByNumberOfArticlesRanking')">
                <v-icon>get_app</v-icon>
              </v-btn>
            </div>
            <v-card style="min-height: 432px" class="d-flex justify-center align-center">
              <v-card-text class="px-0 pt-0">
                <center id="HomeSourcesByNumberOfArticlesRanking" ref="HomeSourcesByNumberOfArticlesRanking">
                  <SourcesByNumberOfArticles v-bind:options="{}" v-bind:filters="getFilters"></SourcesByNumberOfArticles>
                </center>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>

      <v-flex xs6 v-if="getLatestListings">
        <v-expansion-panel :value=expansionValue>
          <v-expansion-panel-content class="secondary accent--text" expand-icon="fa-angle-down accent--text">
            <div slot="header">
              <div style="float: left;margin-bottom: 0;line-height: 50px">Latest Sources</div>
              <v-btn flat icon color="primary" class="float: right" @click.stop="snap($refs['HomeSourcesByDateRanking'], 'HomeSourcesByDateRanking')">
                <v-icon>get_app</v-icon>
              </v-btn>
            </div>
            <v-card style="min-height: 432px" class="d-flex justify-center align-center">
              <v-card-text class="px-0 pt-0">
                <center id="HomeSourcesByDateRanking" ref="HomeSourcesByDateRanking">
                  <SourcesByDate v-bind:options="{}" v-bind:filters="getFilters"></SourcesByDate>
                </center>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>

      <v-flex :class="getLastItemClass" v-if="getTopListings">
        <v-expansion-panel :value=expansionValue>
          <v-expansion-panel-content class="secondary accent--text" expand-icon="fa-angle-down accent--text">
            <div slot="header">
              <div style="float: left;margin-bottom: 0;line-height: 50px">Top Articles<span class="caption pl-1">(sorted by number of retweets)</span></div>
              <v-btn flat icon color="primary" class="float: right" @click.stop="snap($refs['HomeArticlesByNumberOfRetweetsRanking'], 'HomeArticlesByNumberOfRetweetsRanking')">
                <v-icon>get_app</v-icon>
              </v-btn>
            </div>
            <v-card style="min-height: 432px" class="d-flex justify-center align-center">
              <v-card-text class="px-0 pt-0">
                <center id="HomeArticlesByNumberOfRetweetsRanking" ref="HomeArticlesByNumberOfRetweetsRanking">
                  <ArticlesByNumberOfRetweets v-bind:options="{}" v-bind:filters="getFilters"></ArticlesByNumberOfRetweets>
                </center>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>

      <v-flex :class="getLastItemClass" v-if="getLatestListings">
        <v-expansion-panel :value=expansionValue>
          <v-expansion-panel-content class="secondary accent--text" expand-icon="fa-angle-down accent--text">
            <div slot="header">
              <div style="float: left;margin-bottom: 0;line-height: 50px">Latest Articles</div>
              <v-btn flat icon color="primary" class="float: right" @click.stop="snap($refs['HomeArticlesByDateRanking'], 'HomeArticlesByDateRanking')">
                <v-icon>get_app</v-icon>
              </v-btn>
            </div>
            <v-card style="min-height: 432px" class="d-flex justify-center align-center">
              <v-card-text class="px-0 pt-0">
                <center id="HomeArticlesByDateRanking" ref="HomeArticlesByDateRanking">
                  <ArticlesByDate v-bind:options="{}" v-bind:filters="getFilters"></ArticlesByDate>
                </center>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { snap } from '@/helpers/snapshots'
import Filters from './Filters.vue'
import Counters from './Counters.vue'
import TweetsVolumeBarChart from './charts/TweetsVolumeBarChart.vue'
import TweetsTypesPieChart from './charts/TweetsTypesPieChart.vue'
import TweetsLocationsPieChart from './charts/TweetsLocationsPieChart.vue'
import HashtagCloud from './clouds/HashtagCloud.vue'
import EmojiCloud from './clouds/EmojiCloud.vue'
import TweetsByRetweets from './rankings/TweetsByRetweets.vue'
import TweetsByDate from './rankings/TweetsByDate.vue'
import SourcesByNumberOfArticles from './rankings/SourcesByNumberOfArticles.vue'
import SourcesByDate from './rankings/SourcesByDate.vue'
import ContributorsByNumberOfFollowers from './rankings/ContributorsByNumberOfFollowers.vue'
import ContributorsByDate from './rankings/ContributorsByDate.vue'
import HashtagsByNumberOfTweets from './rankings/HashtagsByNumberOfTweets.vue'
import HashtagsByDate from './rankings/HashtagsByDate.vue'
import ArticlesByNumberOfRetweets from './rankings/ArticlesByNumberOfRetweets.vue'
import ArticlesByDate from './rankings/ArticlesByDate.vue'

export default {
  data () {
    return {
      expansionValue: 0,
      tweetsVolumeBarChartDialog: false,
      hashtagCloudDialog: false,
      emojiCloudDialog: false,
      countriesPieChartDialog: false,
      tweetTypesPieChartDialog: false
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn', 'currentUser']),
    ...mapGetters('toggles', ['getLatestListings', 'getTopListings', 'getFiltersChips']),
    ...mapGetters('filters', ['getFilters']),
    getLastItemClass: function () {
      return (this.getTopListings && this.getLatestListings) ? 'xs6' : 'xs12'
    }
  },
  methods: {
    ...mapMutations('notification', ['notify']),
    ...mapMutations('filters', ['setFilters', 'resetFilters']),
    snap
  },
  components: {
    Filters,
    Counters,
    HashtagCloud,
    EmojiCloud,
    TweetsTypesPieChart,
    TweetsLocationsPieChart,
    TweetsVolumeBarChart,
    TweetsByRetweets,
    TweetsByDate,
    SourcesByNumberOfArticles,
    SourcesByDate,
    ContributorsByNumberOfFollowers,
    ContributorsByDate,
    HashtagsByNumberOfTweets,
    HashtagsByDate,
    ArticlesByNumberOfRetweets,
    ArticlesByDate
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Home.vue